import { horaEmBrasilia } from './format-date';

/**
 * Horário comercial de Brasília — a régua do AVISO de liberação (09/09/2026).
 *
 * 🔴 Por que existe: a liberação de 08/09 foi às 22h10, e o coletor que morreu
 * com ela só foi visto de madrugada. Às 9h teria sido visto em minutos. A tela
 * AVISA quando a liberação acontece fora deste horário — não impede: quem
 * libera às 22h sabendo o risco continua podendo.
 *
 * ⚠️ Uma definição só, usada pela ficha e pelo lote — texto e régua juntos.
 */
export function foraDoHorarioComercial(agora = new Date()): boolean {
  // #484: a hora e o dia vêm do relógio de Brasília da função única.
  const { hora, diaDaSemana } = horaEmBrasilia(agora);
  const fimDeSemana = diaDaSemana === 0 || diaDaSemana === 6;
  return fimDeSemana || hora < 8 || hora >= 18;
}

export const AVISO_FORA_DO_HORARIO =
  'Fora do horário comercial: se a versão nova emudecer, ninguém está olhando — foi ' +
  'exatamente a liberação das 22h10 de 08/09. Liberar de manhã deixa o problema aparecer ' +
  'com gente acordada. Isto é um aviso, não um bloqueio.';
